import { Injectable } from '@angular/core';

@Injectable()
export class UtilityService {

  private itemColors: string[] = [
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#1976D2',
    '#303F9F',
    '#FF6F00',
  ];

  constructor() { }

  getRandomItemBGColor() {
    return this.itemColors[Math.floor(Math.random() * 6) % this.itemColors.length];
  }
}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/utility.service.ts